<template>
<div>
    <law-matter-process-result-form :getLawMatterProcessResultList="getLawMatterProcessResultList" ref="lawMatterProcessResultFormModal"></law-matter-process-result-form>
    <b-row>
        <b-col class="col-12">
            <div style="float:left;" class="custom-search d-flex justify-content-end">
                <b-form-group>
                    <div class="d-flex align-items-center">
                        <b-form-input size="sm" v-model="searchTerm" :placeholder="$t('others.search')" type="text" class="d-inline-block" />
                    </div>
                </b-form-group>
            </div>
            <div style="float:right;" class="custom-search d-flex justify-content-end">
                <b-form-group>
                    <div class="d-flex align-items-center">
                        <b-button style="float:right; border-color:#6B7280; color:#374151;" class="mr-1" size="sm" variant="outline-secondary" @click="getInfo(0)">{{ $t('lawMatterProcessResult.add') }}</b-button>
                        <b-button style="float:right; border-color:#6B7280; color:#374151;" size="sm" variant="outline-secondary" @click="exportExcel()">{{ $t('others.excel') }}</b-button>
                    </div>
                </b-form-group>
            </div>
        </b-col>
    </b-row>
    <!-- table -->
    <vue-good-table id="lawMatterProcessResultTable" ref="lawMatterProcessResultTable" :columns="columns" :rows="rows" styleClass="vgt-table condensed tableSize" :search-options="{
        enabled: true,
        externalQuery: searchTerm
      }" :select-options="{
        enabled: false,
        selectOnCheckboxOnly: true, 
        selectionInfoClass: 'custom-class',
        selectionText: 'rows selected',
        clearSelectionText: 'clear',
        disableSelectInfo: true, 
        selectAllByGroup: true,
      }" :pagination-options="{
        enabled: true,
        perPage: pageLength
      }" theme="my-theme">
        <div slot="emptystate">
            {{ $t('dataTable.data_not_found') }}
        </div>
        <!-- Row: Table Row -->
        <template slot="table-column" slot-scope="props">
            <span v-if="props.column.field === 'lawMatterTypeName'" class="text-nowrap">
                {{ $t('lawMatterProcessResult.law_matter_type_name') }}
            </span>
            <span v-if="props.column.field === 'name'" class="text-nowrap">
                {{ $t('lawMatterProcessResult.name') }}
            </span>
            <span v-if="props.column.field === 'description'" class="text-nowrap">
                {{ $t('lawMatterProcessResult.description') }}
            </span>
            <span v-else-if="props.column.field === 'process'"></span>
        </template>
        <!-- Column: Table Column -->
        <template slot="table-row" slot-scope="props">
            <!-- Column: Description -->
            <span v-if="props.column.field === 'description'">
                <span
                    class="wh-clamp-2"
                    v-b-tooltip.hover="{ title: props.row.description, customClass: 'wh-tooltip' }">
                    {{ props.row.description }}
                </span>
            </span>
            <!-- Column: Process -->
            <span v-else-if="props.column.field === 'process'">
                <list-actions-dropdown :actions="[
                    { icon: 'EditIcon', label: $t('others.edit'), handler: () => getInfo(props.row.id) },
                    { icon: 'XIcon', label: $t('others.delete'), color: '#DC2626', handler: () => deleted(props.row) }
                ]" />
            </span>
        </template>

        <!-- pagination -->
        <template slot="pagination-bottom" slot-scope="props">
            <div class="d-flex justify-content-between flex-wrap">
                <div class="d-flex align-items-center mb-0 mt-1">
                    <span class="text-nowrap"> {{ $t('dataTable.total') }} {{ props.total }} {{ $t('dataTable.record') }}
                    </span>
                    <b-form-select v-model="pageLength" :options="['10', '25', '50', '100']" class="mx-1" @input="(value) => props.perPageChanged({ currentPerPage: value })" />
                    <span class="text-nowrap"> {{ $t('dataTable.row_is_show') }} </span>
                </div>
                <div>
                    <b-pagination :value="1" :total-rows="props.total" :per-page="pageLength" first-number last-number align="right" prev-class="prev-item" next-class="next-item" class="mt-1 mb-0" @input="(value) => props.pageChanged({ currentPage: value })">
                        <template #prev-text>
                            <feather-icon icon="ChevronLeftIcon" size="18" />
                        </template>
                        <template #next-text>
                            <feather-icon icon="ChevronRightIcon" size="18" />
                        </template>
                    </b-pagination>
                </div>
            </div>
        </template>
    </vue-good-table>
</div>
</template>

  
<script>
export default {
    data() {
        return {
            pageLength: 50,
            dir: false,
            columns: [
                {
                    label: this.$t('lawMatterProcessResult.law_matter_type_name'),
                    field: `lawMatterTypeName`,
                },
                {
                    label: this.$t('lawMatterProcessResult.name'),
                    field: `name`,
                },
                {
                    label: this.$t('lawMatterProcessResult.description'),
                    field: `description`,
                },
                {
                    label: '',
                    field: 'process',
                    sortable: false,
                    width: '10em'
                },
            ],
            rows: [],
            searchTerm: '',
        }
    },
    mounted() {
        this.getLawMatterProcessResultList()
    },
    methods: {
        async deleted(data) {
            data = {
                id: data.id
            }
            const controller = {
                name: 'LawMatterProcessResult'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$DeleteConfirm().then(result => {
                if (result.value) {
                    this.$store.dispatch('moduleAuth/delete', payload).then((response) => {
                        if (response.data.resultStatus == true) {
                            this.$DeleteAlert()
                            this.getLawMatterProcessResultList()
                        } else {
                            this.$WarningAlert(response.data.resultMessage)
                            this.getLawMatterProcessResultList()
                        }
                    })
                }
            })
        },
        async getInfo(id) {
            this.$refs.lawMatterProcessResultFormModal.showInfo(id)
        },
        getLawMatterProcessResultList() {
            this.rows = []
            const controller = {
                name: 'LawMatterProcessResult'
            }
            const payload = {
                controller: controller
            }
            this.$store.dispatch('moduleAuth/getList', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    response.data.lawMatterProcessResultList.forEach(element => {
                        this.rows.push(element)
                    })
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        },
        exportExcel() {
            const controller = {
                name: 'LawMatterProcessResult',
                actionName: 'CanExport'
            }
            const data = {
                columnList: this.columns,
                DataList: this.rows
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.$downloadFile("Islem_Sonuclari", response.data.base64, 'xlsx')
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        }
    },
}
</script>
  
<style lang="scss">
.tableSize {
    font-size: 13px !important;
    border-collapse: collapse;
    width: 100%;
    max-width: 100%;
    table-layout: auto;
}
</style>
